import React from "react";
import "../singapore.css";
import Accomodation from "../assets/DCL-DA_Concierge Royal Suite - Elsa (Main Bedrm).jpg";
import Dining  from "../assets/DCL-DA (Main Dining - Navigators Club).jpg";
import Activity from "../assets/RCI_PDC_052019_JordanDani_Day5_C1_Splash_Summit_Slingshot_Raft_015967_RET_CMYK (1).jpg";
import Entertain from "../assets/DCL-DA_Entertainment (Disney Seas Your Adventure).jpg";


const features = [
  {
    id: 1,
    title: "Accommodations",
    description: "Comfortable staterooms and luxurious suites to relax after a day of adventure.",
    image: Accomodation
  },
  {
    id: 2,
    title: "Dining",
    description: "World-class cuisine with multiple restaurants, cafes, and room service options.",
    image: Dining
  },
  {
    id: 3,
    title: "Activities",
    description: "Exciting onboard activities including pools, water slides, rock climbing, and more.",
    image: Activity
  },
  {
    id: 4,
    title: "Entertainment",
    description: "Broadway-style shows, live music, comedy performances, and themed parties.",
    image: Entertain
  }
];

const WhatsIncluded = () => {
  return (
    <section id="whats-included" className="whats-included">
      <div className="container">
        <div className="header">
          <h2 className="title">What's Included in Your Cruise</h2>
          <p className="subtitle">
            Enjoy all-inclusive amenities and services that make cruising the best value for your vacation.
          </p>
        </div>

        <div className="features-grid">
          {features.map((feature) => (
            <div key={feature.id} className="feature-card">
              <div className="feature-content">
                <img className="feature-image" src={feature.image} alt="Benefits" />
                <h3 className="feature-title">{feature.title}</h3>
                <p className="feature-description">{feature.description}</p>
              </div>
            </div>
          ))}
        </div>

        {/* <div className="value-section">
          <div className="value-content">
            <div>
              <h3 className="value-title">All-Inclusive Value</h3>
              <p className="value-description">
                Our cruise packages offer exceptional value with accommodations, dining, activities, and entertainment all included in one price.
                Additional premium experiences, specialty dining, and shore excursions are available for an enhanced cruise experience.
              </p>
            </div>
            <div className="value-badge">
              <div className="badge-main">4-in-1</div>
              <div className="badge-sub">Exceptional Value</div>
            </div>
          </div>
        </div> */}
      </div>
    </section>
  );
};

export default WhatsIncluded;
